export const DEFAULT_HOLES_OPEN_VALUES = 1;
